import { render, staticRenderFns } from "./NavigationCareProviderMenuItem.vue?vue&type=template&id=45078c7a&scoped=true&functional=true&"
import script from "./NavigationCareProviderMenuItem.vue?vue&type=script&lang=js&"
export * from "./NavigationCareProviderMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./NavigationCareProviderMenuItem.vue?vue&type=style&index=0&id=45078c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "45078c7a",
  null
  
)

export default component.exports